export default __webpack_public_path__ + "static/media/226.f0d74785.png";